import { render, staticRenderFns } from "./AddPurchasesDeliveryPage.vue?vue&type=template&id=7cc91032"
import script from "./AddPurchasesDeliveryPage.vue?vue&type=script&lang=js"
export * from "./AddPurchasesDeliveryPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports